"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.auPersist = void 0;
exports.persistState = persistState;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _immutable = _interopRequireDefault(require("immutable"));
var _transitImmutableJs = _interopRequireDefault(require("transit-immutable-js"));
const LOCAL_STORAGE_KEY = 'auPersist';
const auPersist = {
  read() {
    let localImmutableState = _immutable.default.Map();
    try {
      const localAuPersist = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (localAuPersist) {
        localImmutableState = _transitImmutableJs.default.fromJSON(localAuPersist);
      }
    } catch (e) {
      console.warn('Local storage state is invalid and cannot be reloaded! Resetting local storage state'); // eslint-disable-line no-console
      this.clear();
    }
    return localImmutableState;
  },
  write(imData) {
    localStorage.setItem(LOCAL_STORAGE_KEY, _transitImmutableJs.default.toJSON(imData));
    return imData;
  },
  clear() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
};
exports.auPersist = auPersist;
function persistState(state) {
  // Will let use chain function calls to a single object that applies those
  // calls to both local storage and passed in state
  return {
    call(...args) {
      const fn = args[0];
      state = state[fn](...(0, _slice.default)(args).call(args, 1));
      auPersist.write(auPersist.read()[fn](...(0, _slice.default)(args).call(args, 1)));
      return this;
    },
    get state() {
      return state;
    }
  };
}